<template>
    <div class="workflows__log">
        <div class="workflows__log_header">
            <view-actions
                :title="'Workflows log'"
                :cancel-button-active="false"
                :submit-button-active="false"
            />
        </div>
        <div class="workflows__log_main">
            <component-list
                :component-table="LmsSuperadminWorkflowsLogTable"
                :component-table-name="'workflows'"
                :filter-select-active="true"
                :filter-select-items="filtersSelect"
                :empty-state-title="'Workflows log will appear here.'"
                :get-pagination-getter="'getLmsSuperadminWorkflowsLogPagination'"
                :get-items-getter="'getLmsSuperadminWorkflowsLog'"
                :get-items-dispatch="'lmsSuperadminWorkflowsLogGet'"
                :get-items-dispatch-trigger-name="'get-workflows-log'"
                :item-name="['workflows log', 'workflows logs']"
                :table-preferences-active="true"
            />
        </div>
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import ComponentList from '@/components/default/shared/ComponentList'
import LmsSuperadminWorkflowsLogTable from '@/components/lms/superadmin/workflows/log/LmsSuperadminWorkflowsLogTable'

export default {
  name: 'lms-superadmin-workflows-log',
  components: { ComponentList, ViewActions },
  data () {
    return {
      LmsSuperadminWorkflowsLogTable
    }
  },
  computed: {
    filtersSelect () {
      return [
        {
          key: 'dates',
          label: 'Dates range',
          type: 'date'
        },
        {
          key: 'workflowTrigger',
          label: 'On completion of',
          type: 'multiselect',
          getItemsGetter: 'getEbsCoursesMappedIdNameStatusLabels',
          getItemsGetterMapped: 'getEbsCoursesMappedLabelValue',
          getItemsDispatch: 'ebsCoursesGet',
          getPaginationGetter: 'getEbsCoursesPagination',
          itemName: ['course', 'courses'],
          searchQueryable: true,
          tableLabels: [
            {
              key: 'name',
              title: 'Name',
              type: 'string',
              sortable: true,
              queryable: true
            }
          ]
        },
        {
          key: 'enrolTo',
          label: 'Enrol to',
          type: 'multiselect',
          getItemsGetter: 'getEbsCoursesMappedIdNameStatusLabels',
          getItemsGetterMapped: 'getEbsCoursesMappedLabelValue',
          getItemsDispatch: 'ebsCoursesGet',
          getPaginationGetter: 'getEbsCoursesPagination',
          itemName: ['course', 'courses'],
          searchQueryable: true,
          tableLabels: [
            {
              key: 'name',
              title: 'Name',
              type: 'string',
              sortable: true,
              queryable: true
            }
          ]
        },
        {
          key: 'result',
          label: 'Result',
          type: 'checkbox',
          values: [
            {
              label: 'Success',
              value: 'true'
            },
            {
              label: 'Fail',
              value: 'false'
            }
          ]
        }
      ]
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/workflows/_workflowslog.scss";
</style>
